import Vue from "vue";
import { BootstrapVue } from "bootstrap-vue";
import MyComponents from "./components";
import App from "./App.vue";
import router from "./router";
import VueKatex from "vue-katex";
import { store } from "./store";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "./assets/css/style.css";
import "./assets/css/utility.css";
import "katex/dist/katex.min.css";

// Install BootstrapVue
Vue.use(BootstrapVue);
Vue.use(MyComponents);

Vue.config.productionTip = false;

import helpers from './helpers/global';
Vue.use({
  install() {
    Vue.helpers = helpers;
    Vue.prototype.$helpers = helpers;
  }
});

Vue.use(VueKatex, {
  globalOptions: {
    //... Define globally applied KaTeX options here
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
